import { IBatch } from 'src/types/interfaces/IBatch'

export const getBatchFilename = (batch: IBatch) =>
  batch.originalFile ? batch.originalFile : batch.filename ? batch.filename : '(Manual entry)'

export const getBatchFilenameExtention = (batch?: Pick<IBatch, 'filename'>) =>
  batch?.filename ? batch.filename.split('.').slice(-1)[0] : ''
